var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"device-type"},[(_vm.model === 'cmt')?[_vm._v("Cromite")]:(_vm.model === 'slc')?[_vm._v("Alltesta")]:[_vm._v("Unknown type ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }